import type { NotificationModel } from "@/components/Notifications/notificationModels"
import type { NotificationItem } from "@/types/notifications"
import { resolveNotificationDisplayTitle } from "@/utils/notificationDisplay"

export function formatNotificationTimeAgo(isoDate: string): string {
  const date = new Date(isoDate)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffMins = Math.floor(diffMs / 60000)
  const diffHours = Math.floor(diffMs / 3600000)
  const diffDays = Math.floor(diffMs / 86400000)
  if (diffMins < 1) return "Just now"
  if (diffMins < 60) return `${diffMins} minute${diffMins !== 1 ? "s" : ""} ago`
  if (diffHours < 24) return `${diffHours} hour${diffHours !== 1 ? "s" : ""} ago`
  if (diffDays < 7) return `${diffDays} day${diffDays !== 1 ? "s" : ""} ago`
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric" })
}

export function mapNotificationItemToModel(n: NotificationItem): NotificationModel {
  return {
    id: n.id,
    type: (n.category as NotificationModel["type"]) ?? "system",
    title: resolveNotificationDisplayTitle(n.title, n.eventKey, n.data),
    message: n.bodyMarkdown,
    time: formatNotificationTimeAgo(n.createdAt),
    avatarName: "Tessera",
    avatarSrc: "",
    isRead: n.statusInApp === "read",
    eventKey: n.eventKey ?? null,
    details: n.data as NotificationModel["details"],
  }
}
